import React from 'react';
import { SectionHeading } from '../../../../ui';

export function LandingDirections() {
  return (
    <section className="section section--directions content-width" id="directions" data-figma-node="125:48227" aria-labelledby="directions-title">
      <div className="directions-intro">
        <SectionHeading
          title={<>Куда чаще всего <br />везут</>}
          titleId="directions-title"
          description="Топ-направления этой недели — выберите свой маршрут или впишите любой другой"
        />
        <div className="directions-intro__image">
          <img src="/assets/landing/directions-dog.webp" alt="Собака в автомобиле на фоне Эйфелевой башни" />
        </div>
      </div>
      <div className="directions-grid" id="directions-grid"></div>
    </section>
  );
}
